module.exports = __webpack_public_path__ + "static/media/logocodegalaxy.c8f8a253.svg";